import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {settingsReceived} from "../../../slice/groups/set-groups-lessons/set-setting-group/setSettingGroup";
import {SettingGroupsResponse} from "../../../types/settingGroups";




export const fetchChangeSettingGroup = createAsyncThunk<SettingGroupsResponse, string | undefined>(
    'groups/fetchSettingGroupData',
    async (groupId, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('Не найден токен в локальном хранилище.');
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.get<SettingGroupsResponse>(
                `/api/groups/${groupId}/settings`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            thunkAPI.dispatch(settingsReceived(response.data.data));
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
